import React, {
  Fragment,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Card, CardBody, CardHeader, Col, Popover, Table } from "reactstrap";
import "./style.scss";
import styled from "styled-components";
import DangKyPhatBieusEndpoint from "../../../../../service/Meet/DangKyPhatBieusEndpoint";
import {
  CHECK_CONFIRM,
  CHECK_CONFIRM_INPUT,
  CHECK_ERROR,
  CHECK_SUCCESS,
  CHECK_WARNING,
} from "../../../../../components/alert/Alert";
import { PopoverBody } from "reactstrap/lib";
import {
  Enum_Meeting_Status,
  Enum_Trang_Thai_Phat_Bieu,
  _Enum_Loai_Phat_Bieu,
  _Enum_Trang_Thai_Noi_Dung,
  _Enum_Trang_Thai_Phat_Bieu,
} from "../../../../action/defaultEnums";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import ButtonMate from "@mui/material/Button";
import Chart from "./Chart";
import { TOKEN_CLIENT_INFO } from "../../../../../actions/constants";
import { StorageEndpoint } from "../../../../../service/GateWay";
import { formatDatetime } from "../../../../../actions/util";
import { Avatar } from "../../../../../others";
import { cumulativeOffset } from "../Main";
// import MicRecorder from 'mic-recorder-to-mp3';
import Tranfer from "./Tranfer";
import { useSelector } from "react-redux";
import { TypeEnums } from "../reloadConstants";
import ProcessAudioToText from "./ProcessAudioToText";
// import Recording from './Recording';
import { toDataUrlAvatar } from "../../../../../components/avatar";
// eslint-disable-next-line no-unused-vars
import {
  Popover as PopoverMUI,
  FormControlLabel,
  Switch,
  Tooltip,
  Divider,
  Icon,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { KhungNoiDungsEndpoint } from "../../../../../service/Meet";
import RecordAudio from "./RecordAudio";
import ListAudio from "./ListAudio";
import ScheduleIcon from "@mui/icons-material/Schedule";
import AddIcon from "@mui/icons-material/Add";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import AudioFileIcon from "@mui/icons-material/AudioFile";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import CancelIcon from "@mui/icons-material/Cancel";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import MicIcon from "@mui/icons-material/Mic";
import IconButton from "@mui/material/IconButton";

// Firefox 1.0+
//  var isFirefox = typeof InstallTrigger !== 'undefined';
// var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
export const Action = styled.td`
  vertical-align: middle !important;
  text-align: center;
`;
export const ActionText = styled.td`
  vertical-align: middle !important;
  text-align: left;
`;
export function compare(a, b) {
  // Use toUpperCase() to ignore character casing
  const thuTuA = a.thuTu;
  const thuTuB = b.thuTu;

  let comparison = 0;
  if (thuTuA > thuTuB) {
    comparison = 1;
  } else if (thuTuA < thuTuB) {
    comparison = -1;
  }
  return comparison;
}
//color media
const ENUM_COLOR_PHATBIEU = {
  [_Enum_Trang_Thai_Phat_Bieu.DONE]: "green",
  [_Enum_Trang_Thai_Phat_Bieu.ON]: "blue",
  [_Enum_Trang_Thai_Phat_Bieu.OFF]: "orange",
};

//-------------------
export const ListenAudio = memo(
  forwardRef(({ path, style }, ref) => {
    // eslint-disable-next-line no-unused-vars
    const [key, setKey] = useState(0);

    useImperativeHandle(
      ref,
      () => ({ reload: () => setKey((pre) => pre + 1) }),
      [],
    );

    // eslint-disable-next-line no-unused-vars
    // const [audio, setAudio] = useState(null)
    // const getAudio = useCallback(async (path) => {
    //   const data = await StorageEndpoint.getImgByPath(path);
    //   setAudio(data)
    // }, [])
    // useEffect(() => { if (path) getAudio(path); }, [getAudio, path]);
    return (
      <audio
        id="player"
        style={style}
        controls
        src={
          path &&
          StorageEndpoint.getDocUrlByPath(
            `${path}?noCache=${Math.floor(Math.random() * 1000000)}`,
          )
        }
      />
    );
  }),
);

const ActionPhatBieu = memo((props) => {
  const {
    isChuTri,
    isDienBien,
    handleAllow,
    deletePhatBieu,
    item,
    showDelete,
    stopPhatBieu,
  } = props;
  if (isChuTri) {
    switch (item.daPhatBieu) {
      case _Enum_Trang_Thai_Phat_Bieu.OFF:
        return !isDienBien ? (
          <span className="d-flex justify-content-center">
            <Tooltip title="Phát biểu" placement="top">
              <IconButton
                size="small"
                onClick={() => handleAllow(item)}
                sx={{ color: "#1976d2", mr: 0.5 }}
              >
                <HowToRegIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            {showDelete && (
              <Tooltip title="Xóa" placement="top">
                <IconButton
                  size="small"
                  onClick={() => deletePhatBieu(item)}
                  sx={{ color: "#d32f2f" }}
                >
                  <CancelIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </span>
        ) : (
          <></>
        );
      case _Enum_Trang_Thai_Phat_Bieu.ON:
        return !isDienBien ? (
          <span
            className="d-flex justify-content-center align-items-center"
            style={{ color: "blue" }}
          >
            <div className={`badge bg-${ENUM_COLOR_PHATBIEU["ON"]}-lt`}>
              Đang phát biểu
            </div>
            <Tooltip title="Dừng phát biểu" placement="right">
              <IconButton
                size="small"
                onClick={() => stopPhatBieu(item)}
                sx={{ color: "#d32f2f" }}
              >
                <StopCircleIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </span>
        ) : (
          <></>
        );
      default:
        return (
          <div
            className={`badge bg-${ENUM_COLOR_PHATBIEU[item.daPhatBieu]}-lt`}
          >
            <ScheduleIcon
              sx={{ fontSize: 14, mr: 0.5, verticalAlign: "middle" }}
            />
            {formatDatetime(item.phatBieuTai)}
          </div>
        );
    }
  } else {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <span className={`badge bg-${ENUM_COLOR_PHATBIEU[item.daPhatBieu]}-lt`}>
          {Enum_Trang_Thai_Phat_Bieu[item.daPhatBieu]}
          {item.phatBieuTai && (
            <div>
              <small>
                <Icon>access_time</Icon>
                {formatDatetime(item.phatBieuTai)}
              </small>
            </div>
          )}
        </span>
        {showDelete && (
          <Tooltip title="Hủy" placement="right">
            <IconButton
              size="small"
              onClick={() => deletePhatBieu(item)}
              sx={{ color: "#d32f2f" }}
            >
              <CancelIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </div>
    );
  }
});

const useStyles = makeStyles((theme) => ({
  fab: {
    minHeight: "20px",
    width: "auto",
    height: "auto",
  },
  secondText: {
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.43",
    letterSpacing: "0.01071em",
    marginBottom: "0px",
    color: "darkgray",
  },
  root: {
    padding: "2px",
  },
  icon: {
    minWidth: "35px",
  },
}));
//-----------------------
const DangKyPhatBieu = forwardRef(
  ({ khungNoiDungId, isView, isDienBien, dataND }, ref) => {
    const [phatBieus, setPhatBieus] = useState([]);
    const [specified, setSpecified] = useState(null);
    // const [anchorEl, setAnchorEl] = useState(null);

    //audio
    const [openPopAudio, setOpenPopAudio] = useState(null);
    const [stateMedia, setStateMedia] = useState(null);
    const [openAudioToText, setOpenAudioToText] = useState(null);
    const { isChuTri, thamDus, noiDung } = useSelector(
      (state) => state.meetingRProcess,
    );
    const [isRegister, setIsRegister] = useState(true);
    const [openListAudio, setOpenListAudio] = useState(false);
    const visible = useRef();

    //------------
    const refChart = useRef();
    const refAudio = useRef();
    const classes = useStyles();

    //--------PhienHop------
    const { phienHop } = useSelector((state) => state.meetingRProcess);

    useEffect(() => {
      dataND && setIsRegister(!dataND.tatDangKi);
    }, [dataND]);

    const getDangKyPhatBieu = useCallback(async (noiDungId, dataNotify) => {
      const { isnew, isChuTri } = dataNotify || {};
      const { value: phatBieus } =
        await DangKyPhatBieusEndpoint.getDataByIDNoiDung(noiDungId);
      phatBieus.sort(compare);
      phatBieus.forEach((pb, i, arr) => {
        const {
          thanhPhanThamDu: { nhanSu, khachMoi },
          ...data
        } = pb;
        arr[i] = {
          ...data,
          userId: nhanSu ? nhanSu.userId : khachMoi?.userId,
          nhanSuId: nhanSu?.id,
          khachMoiId: khachMoi?.id,
        };
      });
      if (isnew && isChuTri)
        CHECK_SUCCESS(
          null,
          "Thông báo",
          `<span>Cán bộ <Label className="bold"> ${phatBieus[0].name}</Label> vừa đăng ký phát biểu</span>`,
        );
      setPhatBieus(phatBieus);
    }, []);

    const requestRecorder = useCallback(async () => {
      const { state } = await navigator.permissions.query({
        name: "microphone",
      });
      if (state === "denied") {
        return Promise.reject("Vui lòng cho phép ứng dụng truy cập Microphone");
      } else {
        return true;
      }
    }, []);

    const startRecording = useCallback(
      async (phatBieu, openRecoder = null) => {
        try {
          if (isChuTri && !openRecoder) {
            await DangKyPhatBieusEndpoint.openRecordAudio(phatBieu.id);
          } else {
            if (!["hidden", ""].includes(visible.current)) {
              const res = await requestRecorder();
              if (res) {
                // await recorder.current.start()
                setStateMedia((pre) => {
                  let state = { ...pre };
                  state = { ...state, data: phatBieu, isOpen: true };
                  return state;
                });
              }
            }
          }
        } catch (error) {
          CHECK_WARNING(error || "Thao tác không thành công!");
        }
      },
      [isChuTri, requestRecorder],
    );

    const getDangKyPhatBieuWithID = useCallback(
      async (idPhatBieu, dataNotify) => {
        const { isnew, isChuTri, type } = dataNotify || {};
        const {
          thanhPhanThamDu: { nhanSu, khachMoi },
          khungNoiDungId,
          ...dangKyPhatBieu
        } = await DangKyPhatBieusEndpoint.getDataByIDOnMeet(idPhatBieu, {
          noLoading: true,
        });
        const nhanSuId = nhanSu?.id || khachMoi?.id;
        dangKyPhatBieu["userId"] = nhanSu ? nhanSu.userId : khachMoi?.userId;
        dangKyPhatBieu["nhanSuId"] = nhanSuId;
        //thông báo
        if (isChuTri && type === 4) {
          if (isnew) {
            // check thêm cho cán bộ
            if (nhanSuId !== TOKEN_CLIENT_INFO.nhanSuId)
              //người phát biểu là chủ trì
              CHECK_SUCCESS(
                null,
                "Thông báo",
                `<span>Cán bộ <Label className="bold"> ${dangKyPhatBieu.name}</Label> vừa đăng ký phát biểu</span>`,
              );
          } else {
            dangKyPhatBieu.daPhatBieu === Enum_Trang_Thai_Phat_Bieu.DONE &&
              CHECK_SUCCESS(
                null,
                "Thông báo",
                `<span>Cán bộ <Label className="bold"> 
        ${dangKyPhatBieu.name}</Label> hoàn thành phát biểu</span>`,
              );
          }
        }
        if (
          isnew &&
          type === 8 &&
          !isChuTri &&
          [TOKEN_CLIENT_INFO.nhanSuId, TOKEN_CLIENT_INFO.khachMoiId].includes(
            nhanSuId,
          )
        ) {
          CHECK_SUCCESS(
            null,
            "Thông báo",
            `<span>Cán bộ <Label className="bold"> ${dangKyPhatBieu.name}</Label> vừa được chỉ định phát biểu</span>`,
          );
        }
        if (khungNoiDungId !== noiDung?.id) {
          const isAllowPhatBieu =
            dangKyPhatBieu.daPhatBieu === _Enum_Trang_Thai_Phat_Bieu.ON &&
            dangKyPhatBieu.thanhPhanThamDuId === thamDus.userThamDu?.id;
          if (isAllowPhatBieu) {
            CHECK_SUCCESS(null, "Thông báo", `Bạn đã được phép phát biểu`);
            startRecording(dangKyPhatBieu);
          }
          return;
        }
        setPhatBieus((pre) => {
          const phatBieus = [...pre];
          const i = phatBieus.findIndex((cur) => cur.id === dangKyPhatBieu.id);
          if (isChuTri) {
            const isAllowPhatBieu =
              dangKyPhatBieu.daPhatBieu === _Enum_Trang_Thai_Phat_Bieu.ON &&
              dangKyPhatBieu.thanhPhanThamDuId === thamDus.userThamDu?.id;
            if (isAllowPhatBieu) {
              CHECK_SUCCESS(null, "Thông báo", `Bạn đã được phát biểu`);
              startRecording(dangKyPhatBieu, true);
            }
            if (i > -1) {
              phatBieus[i] = dangKyPhatBieu;
              return phatBieus;
            } else {
              return [dangKyPhatBieu, ...phatBieus];
            }
          } else {
            if (i > -1) {
              const isAllowPhatBieu =
                dangKyPhatBieu.daPhatBieu === _Enum_Trang_Thai_Phat_Bieu.ON &&
                dangKyPhatBieu.thanhPhanThamDuId === thamDus.userThamDu?.id;
              if (isAllowPhatBieu) {
                CHECK_SUCCESS(null, "Thông báo", `Bạn đã được phát biểu`);
                startRecording(dangKyPhatBieu);
              }
              phatBieus[i] = dangKyPhatBieu;
              return phatBieus;
            } else {
              return [dangKyPhatBieu, ...phatBieus];
            }
          }
        });
      },
      [thamDus, startRecording, noiDung],
    );

    const xoaPhatBieuWithID = useCallback((idPhatBieu) => {
      setPhatBieus((pre) => {
        const phatBieus = [...pre];
        const i = phatBieus.findIndex(
          (cur) => cur.id === idPhatBieu.toLowerCase(),
        );
        if (i > -1) {
          phatBieus.splice(i, 1);
          return phatBieus;
        } else {
          return phatBieus;
        }
      });
    }, []);

    const addAudioToPhatBieu = useCallback(async (audio, phatBieu) => {
      let pathFile = "";
      if (audio) {
        const { resultObj: path } = await DangKyPhatBieusEndpoint.saveAudio(
          phatBieu.id,
          audio,
          { notLoading: true },
        );
        pathFile = path;
      }
      return DangKyPhatBieusEndpoint.updateData(
        phatBieu.id,
        { path: pathFile, daPhatBieu: _Enum_Trang_Thai_Phat_Bieu.DONE },
        { noLoading: true },
      )
        .then((res) => {
          setStateMedia(null);
          CHECK_SUCCESS("Đã lưu dữ liệu ghi âm");
          return true;
        })
        .catch((err) => {
          throw new Error(err);
        });
    }, []);

    // eslint-disable-next-line no-unused-vars
    // const handleStop = useCallback((isRecoding) => {
    //   if (!recorder.current.activeStream) {
    //     return addAudioToPhatBieu(null, isRecoding);
    //   }
    //   return recorder.current.stop().getMp3().then(([buffer, blob]) => {
    //     const file = new File(buffer, `${isRecoding.data.name}.mp3`, {
    //       type: blob.type,
    //       lastModified: Date.now()
    //     });
    //     return addAudioToPhatBieu(file, isRecoding.data);
    //     // const player = new Audio(URL.createObjectURL(file));
    //     // player.controls = true;
    //   }).catch((e) => {
    //     CHECK_ERROR('Ghi âm thất bại');
    //     throw new Error(e);
    //   });
    // }, [addAudioToPhatBieu])

    const handleStop = useCallback(
      async (content) => {
        if (content) {
          const { audio, data } = content;
          // audio.lastModifiedDate = Date.now();
          // audio.name = 'Phát biểu cán bộ';
          return addAudioToPhatBieu(audio, data);
        } else {
          throw new Error();
        }
      },
      [addAudioToPhatBieu],
    );

    const onFocus = () => {
      visible.current = document.visibilityState;
    };

    useEffect(() => {
      window.addEventListener("visibilitychange", onFocus);
    }, []);

    useEffect(() => {
      if (khungNoiDungId) getDangKyPhatBieu(khungNoiDungId);
    }, [getDangKyPhatBieu, khungNoiDungId]);

    const ghiAmPhatBieu = useCallback(
      async (id) => {
        const curPhatBieu = await DangKyPhatBieusEndpoint.getDataByID(
          id.toLowerCase(),
        );
        if (curPhatBieu) startRecording(curPhatBieu);
      },
      [startRecording],
    );

    //reload grpc
    const updateReload = useCallback(
      async ({ idDangKyPhatBieu, ...dataNotify }) => {
        if (idDangKyPhatBieu) {
          switch (dataNotify.type) {
            case TypeEnums.XOAPHATBIEU:
              xoaPhatBieuWithID(idDangKyPhatBieu, dataNotify);
              break;
            case TypeEnums.GHIAMPHATBIEU:
              ghiAmPhatBieu(idDangKyPhatBieu);
              break;
            case TypeEnums.DUNGPHATBIEU:
              refAudio.current.stopRecording();
              break;
            default:
              getDangKyPhatBieuWithID(idDangKyPhatBieu, dataNotify);
              break;
          }
        } else {
          getDangKyPhatBieu(khungNoiDungId, dataNotify);
        }
        return true;
      },
      [
        getDangKyPhatBieu,
        getDangKyPhatBieuWithID,
        ghiAmPhatBieu,
        khungNoiDungId,
        xoaPhatBieuWithID,
      ],
    );

    useImperativeHandle(ref, () => ({ updateReload }), [updateReload]);

    const handleDangKy = useCallback(() => {
      CHECK_CONFIRM_INPUT({ mes: `Nhập nội dung phát biểu ?` }).then((res) => {
        if (res && res.isConfirmed) {
          DangKyPhatBieusEndpoint.dangKyPhatBieu({
            khungNoiDungId,
            type: _Enum_Loai_Phat_Bieu.IN,
            noiDung: res.value,
          })
            .then((res) => {
              CHECK_SUCCESS("Đăng ký thành công");
            })
            .catch((err) => CHECK_WARNING(err.message));
        }
      });
    }, [khungNoiDungId]);

    const handleAllow = useCallback(
      (data) => {
        if (data) {
          const { name, thanhPhanThamDuId } = data;
          const phatBieuCanBo = phatBieus.find(
            (cur) => cur.daPhatBieu === _Enum_Trang_Thai_Phat_Bieu.ON,
          );
          if (!phatBieuCanBo) {
            CHECK_CONFIRM(`Cho phép cán bộ "${name}" phát biểu?`).then(
              (res) => {
                if (res && res.isConfirmed) {
                  DangKyPhatBieusEndpoint.xemPhatBieu({
                    key: khungNoiDungId,
                    key2: thanhPhanThamDuId,
                  })
                    .then((res) => {
                      return;
                    })
                    .catch((err) => CHECK_ERROR("Không thành công!"));
                }
              },
            );
          } else {
            CHECK_WARNING("Đang có 1 cán bộ phát biểu");
          }
        }
      },
      [khungNoiDungId, phatBieus],
    );

    // eslint-disable-next-line no-unused-vars
    const changeAudio = useCallback((e) => {
      const player = document.getElementById("player");
      const file = e.target.files[0];
      const url = URL.createObjectURL(file);
      player.src = url;
    }, []);

    const deletePhatBieu = useCallback(async (phatBieu) => {
      try {
        CHECK_CONFIRM(`Xóa phát biểu cán bộ ${phatBieu.name}?`).then((res) => {
          if (res && res.isConfirmed) {
            DangKyPhatBieusEndpoint.xoaPhatBieu(phatBieu.id)
              .then((res) => {
                return;
              })
              .catch((err) => CHECK_ERROR("Không thành công!"));
          }
        });
      } catch (error) {
        CHECK_ERROR("Thao tác không thành công");
      }
    }, []);

    const stopPhatBieu = useCallback(
      (phatBieu) => {
        const { khachMoiId, nhanSuId } = phatBieu;
        CHECK_CONFIRM(`Dừng phát biểu cán bộ "${phatBieu.name}" ?`).then(
          (res) => {
            if (res && res.isConfirmed) {
              const canBo = thamDus.thamGia.find(
                (cur) => cur.nhanSuId === nhanSuId,
              );
              if (canBo && canBo?.diemDanh) {
                DangKyPhatBieusEndpoint.dungPhatBieu({
                  phienHopId: noiDung.phienHopId,
                  dataId: phatBieu.id,
                  nhanSuId: khachMoiId || nhanSuId,
                  isKhachMoi: khachMoiId ? true : false,
                }).then((res) => {
                  return;
                });
              } else {
                DangKyPhatBieusEndpoint.updateData(
                  phatBieu.id,
                  { daPhatBieu: _Enum_Trang_Thai_Phat_Bieu.DONE },
                  { noLoading: true },
                );
              }
            }
          },
        );
      },
      [noiDung?.phienHopId, thamDus],
    );

    const handleOpenAudioToText = useCallback(async ({ id, path }) => {
      // const {resultObj:text} = await DangKyPhatBieusEndpoint.speechToText(path);
      // const file = await StorageEndpoint.getImgByPath(path);
      // file.lastModifiedDate = new Date();
      // file.name = randomCode();
      setOpenAudioToText({ isExistText: true, idPhatBieu: id, path });
    }, []);

    const renderDangKy = useMemo(() => {
      if (phatBieus && phatBieus.length !== 0) {
        const indexOn = phatBieus.findIndex(
          (cur) => cur.daPhatBieu === _Enum_Trang_Thai_Phat_Bieu.ON,
        );
        if (indexOn > -1) {
          const on = phatBieus[indexOn];
          phatBieus.splice(indexOn, 1);
          phatBieus.unshift(on);
        }
        return phatBieus.map((f, i) => {
          const getPatch = (pb) => {
            const patch = Object.keys(thamDus.urlCanBos).find(
              (cur) => cur === pb.userId,
            );
            return thamDus.urlCanBos[patch]
              ? StorageEndpoint.getDocUrlByPath(thamDus.urlCanBos[patch])
              : toDataUrlAvatar({ shape: "circle", name: pb.name });
          };
          const checkShowDelete = (phatBieu) => {
            if (phatBieu.daPhatBieu === _Enum_Trang_Thai_Phat_Bieu.OFF) {
              switch (phatBieu.loai) {
                case _Enum_Loai_Phat_Bieu.CHIDINH:
                  if (isChuTri) return true;
                  return false;
                default:
                  if (
                    TOKEN_CLIENT_INFO.nhanSuId === phatBieu.nhanSuId ||
                    TOKEN_CLIENT_INFO.khachMoiId === phatBieu.khachMoiId
                  )
                    return true;
                  return false;
              }
            }
            return false;
          };
          const showDelete = checkShowDelete(f);
          return (
            <tr key={"PB" + i}>
              <Action>
                <Avatar url={() => getPatch(f)} />
              </Action>
              <ActionText>
                <span className="d-flex justify-content-between align-items-baseline">
                  <p className="mb-0">{f.name}</p>
                </span>
                <p className={classes.secondText}>{f.tenChucDanh} </p>
              </ActionText>
              <ActionText>
                <span className="d-flex justify-content-start align-items-baseline">
                  <Tooltip title={f.noiDung} aria-label="noiDung">
                    <p className="mb-0 over-text-noidung">{f.noiDung}</p>
                  </Tooltip>
                </span>
              </ActionText>
              <Action>
                {f.path ? (
                  <>
                    <div className="d-flex justify-content-center">
                      <Tooltip title="Nghe phát biểu" placement="top">
                        <IconButton
                          id={"Popover-" + i + f.trangThai}
                          size="small"
                          onClick={() => setOpenPopAudio(f)}
                          sx={{ color: "#1976d2" }}
                        >
                          <PlayCircleIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Chuyển audio sang text" placement="top">
                        <IconButton
                          size="small"
                          onClick={() => handleOpenAudioToText(f)}
                          sx={{ color: "#2e7d32", ml: 0.5 }}
                        >
                          <AudioFileIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </div>
                    {openPopAudio && (
                      <Popover
                        isOpen={f && f.id === openPopAudio.id}
                        target={"Popover-" + i + f.trangThai}
                        toggle={() => setOpenPopAudio(false)}
                        trigger="legacy"
                      >
                        <PopoverBody>
                          <ListenAudio path={f.path} />
                        </PopoverBody>
                      </Popover>
                    )}
                  </>
                ) : (
                  <>
                    {f.daPhatBieu === _Enum_Trang_Thai_Phat_Bieu.ON &&
                      (f.thanhPhanThamDuId === thamDus.userThamDu?.id ||
                        isChuTri) &&
                      !isDienBien && (
                        <>
                          <Tooltip title="Ghi âm" placement="right">
                            <IconButton
                              size="small"
                              onClick={() => startRecording(f)}
                              sx={{ color: "#ed6c02" }}
                            >
                              <MicIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                  </>
                )}
              </Action>
              <Action>
                <ActionPhatBieu
                  key={i + "action"}
                  {...{
                    isChuTri,
                    stopPhatBieu,
                    showDelete,
                    isDienBien,
                    handleAllow,
                    deletePhatBieu,
                    i,
                    item: f,
                  }}
                />
              </Action>
            </tr>
          );
        });
      } else {
        return (
          <tr key={"none-data"}>
            <td colSpan="5" className="text-center">
              Chưa có dữ liệu
            </td>
          </tr>
        );
      }
    }, [
      phatBieus,
      classes,
      openPopAudio,
      thamDus.userThamDu?.id,
      thamDus.urlCanBos,
      isChuTri,
      isDienBien,
      stopPhatBieu,
      handleAllow,
      deletePhatBieu,
      handleOpenAudioToText,
      startRecording,
    ]);

    useEffect(() => {
      const a = document.getElementById("content-register");
      if (a) {
        a.style.height = window.screen.availHeight - cumulativeOffset(a) - 120;
      }
    });

    const tranferCanBo = useMemo(
      () => <Tranfer isOpen={specified} close={() => setSpecified(false)} />,
      [specified],
    );

    // const handleAdd = useCallback(() => {
    //   const input = document.getElementById('VbUpload');
    //   input.click();
    // }, []);
    // eslint-disable-next-line no-unused-vars
    const handleVBChange = useCallback(
      ({
        target: {
          files: [file],
        },
      }) => {
        setOpenAudioToText(file);
      },
      [],
    );

    const renderAction = useMemo(() => {
      return (
        !isView &&
        !isDienBien && (
          <Col md="6" className="text-right d-flex justify-content-end">
            {TOKEN_CLIENT_INFO?.mainRole === "CB" &&
              !isChuTri &&
              noiDung?.trangThai === _Enum_Trang_Thai_Noi_Dung.DangHop && (
                <ButtonMate
                  style={{ padding: "1px 7px", background: "#799b00" }}
                  onClick={handleDangKy}
                  size="small"
                  variant="contained"
                  color="secondary"
                >
                  <AddIcon
                    sx={{ fontSize: 14, mr: 0.5, verticalAlign: "middle" }}
                  />{" "}
                  Đăng ký
                </ButtonMate>
              )}
            {isChuTri &&
              noiDung?.trangThai === _Enum_Trang_Thai_Noi_Dung.DangHop && (
                <ButtonMate
                  style={{ padding: "1px 6px", background: "#799b00" }}
                  onClick={() => setSpecified(khungNoiDungId)}
                  size="small"
                  variant="contained"
                  color="secondary"
                  startIcon={<Icon>swipe_down</Icon>}
                >
                  Chỉ định
                </ButtonMate>
              )}
            <ButtonMate
              className="ml-1"
              onClick={() => refChart.current.setOpenDash(true)}
              style={{ padding: "1px 6px", background: "#0399d7" }}
              size="small"
              variant="contained"
              color="secondary"
              startIcon={<Icon>assessment</Icon>}
            >
              Thống kê
            </ButtonMate>
            {/* <Button className="ml-1" onClick={handleAdd} style={{ height: '100%' }} variant="contained" size="small" color="primary">
        <i class="fa-solid fa-file-audio mr-1" />  Gỡ băng
      </Button> */}
            {/* <input hidden type="file" id="VbUpload" accept=".mp3" onChange={handleVBChange}></input> */}
          </Col>
        )
      );
    }, [noiDung, handleDangKy, isChuTri, isDienBien, isView, khungNoiDungId]);

    const handleSwitchStated = useCallback(
      async (bool) => {
        try {
          setIsRegister(bool);
          await KhungNoiDungsEndpoint.updateData(
            khungNoiDungId,
            { tatDangKi: !bool },
            { noLoading: true },
          );
        } catch (error) {
          console.log(error);
        }
      },
      [khungNoiDungId],
    );

    const handleChuTriPhatBieu = useCallback(() => {
      CHECK_CONFIRM(" ", "Phát biểu ngay bây giờ").then((res) => {
        if (res && res.isConfirmed) {
          DangKyPhatBieusEndpoint.chuTriPhatBieu({
            khungNoiDungId,
            type: _Enum_Loai_Phat_Bieu.IN,
            noiDung: "",
          })
            .then((res) => {
              CHECK_SUCCESS("Đăng ký thành công");
            })
            .catch((err) => CHECK_WARNING(err.message));
        }
      });
    }, [khungNoiDungId]);

    // const open = Boolean(anchorEl);
    // const id = open ? 'simple-popover' : undefined;

    return (
      <Card className="mb-0">
        <CardHeader className="p-2">
          <Col md="6" className="text-white d-flex align-items-center col-md-6">
            <div>Phát biểu ({phatBieus.length})</div>
            {isChuTri && (
              <Fragment>
                <FormControlLabel
                  className="m-0"
                  control={
                    <Switch
                      size="small"
                      color="primary"
                      checked={isRegister}
                      onChange={(e) => handleSwitchStated(e.target.checked)}
                    />
                  }
                />
                {/* //audio for chutri */}
                {TOKEN_CLIENT_INFO?.mainRole !== "TK" && (
                  <>
                    {phienHop.trangThai !== Enum_Meeting_Status.KetThuc && (
                      <Tooltip title="Phát biểu">
                        <ButtonMate
                          style={{
                            marginLeft: "0.5rem",
                            padding: "2px",
                            background: "aliceblue",
                            minWidth: "auto",
                          }}
                          // onClick={(event) => {
                          //   setAnchorEl(event.currentTarget);
                          // }}
                          onClick={handleChuTriPhatBieu}
                        >
                          <Icon color="secondary" fontSize="small">
                            microphone
                          </Icon>
                        </ButtonMate>
                      </Tooltip>
                    )}
                    <Tooltip title="Danh sách phát biểu (cá nhân)">
                      <ButtonMate
                        style={{
                          marginLeft: "0.5rem",
                          padding: "2px",
                          background: "aliceblue",
                          minWidth: "auto",
                        }}
                        onClick={() => {
                          setOpenListAudio(true);
                        }}
                      >
                        <Icon color="secondary" fontSize="small">
                          list_alt
                        </Icon>
                      </ButtonMate>
                    </Tooltip>
                    {/* <PopoverMUI
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={() => setAnchorEl(null)}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <List
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    className={classes.root}
                  >
                    {phienHop.trangThai !== Enum_Meeting_Status.KetThuc && <>
                      <ListItem button onClick={() => {
                        setAnchorEl(null);
                        handleChuTriPhatBieu()
                      }}>
                        <ListItemIcon className={classes.icon}>
                          <Icon color="secondary" fontSize="small">spatial_audio_off</Icon>
                        </ListItemIcon>
                        <ListItemText primary="Phát biểu" />
                      </ListItem>
                      <Divider />
                    </>}

                    <ListItem button onClick={() => {
                      setAnchorEl(null);
                      setOpenListAudio(true)
                    }}>
                      <ListItemIcon className={classes.icon}>
                        <Icon color="secondary" fontSize="small">audio_file</Icon>
                      </ListItemIcon>
                      <ListItemText primary="Danh sách phát biểu (Cá Nhân)" />
                    </ListItem>
                  </List>
                </PopoverMUI> */}
                  </>
                )}
              </Fragment>
            )}
          </Col>
          {renderAction}
        </CardHeader>
        <CardBody className="p-0 table-sticky-dk" id="content-register">
          <Table size="sm" bordered striped>
            <thead>
              <tr>
                <td className="text-center">Ảnh</td>
                <td className="text-center">Họ Tên</td>
                <td className="text-center">Nội dung</td>
                <td className="text-center">Ghi âm</td>
                <td className="text-center">
                  {isChuTri ? "Thao tác" : "Trạng thái"}{" "}
                </td>
              </tr>
            </thead>
            <tbody className="position-sticky overflow-auto">
              {renderDangKy}
            </tbody>
          </Table>
        </CardBody>
        <Chart ref={refChart} phatBieus={phatBieus} />
        <RecordAudio ref={refAudio} {...{ handleStop, stateMedia }} />
        {TOKEN_CLIENT_INFO?.mainRole !== "TK" && (
          <ListAudio
            thamDus={thamDus}
            khungNoiDungId={khungNoiDungId}
            isOpen={openListAudio}
            onClose={() => setOpenListAudio(false)}
          ></ListAudio>
        )}
        {/* <Recording ref={refAudio} {...{ handleStop, stateMedia }} /> */}
        <ProcessAudioToText
          isOpen={openAudioToText}
          onClose={() => setOpenAudioToText(null)}
        />
        {tranferCanBo}
      </Card>
    );
  },
);
export default DangKyPhatBieu;
